import { render, staticRenderFns } from "./ApplicantPrivacyNotice.vue?vue&type=template&id=8fc6a3c4&"
import script from "./ApplicantPrivacyNotice.vue?vue&type=script&lang=js&"
export * from "./ApplicantPrivacyNotice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports